import { MEIOS_PAGAMENTO } from '../../../enums/MeioPagamento';

export const ELETRONIC_TPAGS = [
  MEIOS_PAGAMENTO.credito,
  MEIOS_PAGAMENTO.debito,
  MEIOS_PAGAMENTO.vale_alimentacao,
  MEIOS_PAGAMENTO.vale_refeicao,
  MEIOS_PAGAMENTO.vale_presente,
  MEIOS_PAGAMENTO.vale_combustivel,
  MEIOS_PAGAMENTO.boleto_bancario,
  MEIOS_PAGAMENTO.pix,
  MEIOS_PAGAMENTO.transferencia,
];
